import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getNewsData } from "../api/dataSource";
import "./RecentNews.css";

export default function RecentNews() {
  const [current, setCurrent] = useState(0);
  const [newsData, setNewsData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const data = await getNewsData();
      setNewsData(data);
    };
    fetchData();
  }, []);

  const next = () => {
    if (newsData.length > 0) {
      setCurrent(prev => {
        if (newsData.length === 0) return 0;
        return (prev + 1) % newsData.length;
      });
    }
  };
  
  const prev = () => {
    if (newsData.length > 0) {
      setCurrent(prev => {
        if (newsData.length === 0) return 0;
        return prev === 0 ? newsData.length - 1 : prev - 1;
      });
    }
  };

  const openNews = () => {
    if (newsData.length > 0 && newsData[current]) {
      navigate(`/news?focus=${newsData[current].id}`);
    }
  };

  // Safely get current news item
  const getCurrentNews = () => {
    if (newsData.length > 0 && newsData[current]) {
      return newsData[current];
    }
    return null;
  };

  return (
    <section className="recent-news-section">
      <h1 className="recent-news-heading">Recent News</h1>

      <div className="carousel-wrapper">
        <div className="carousel-card" onClick={openNews}>
          {getCurrentNews() ? (
            <>
              <img
                src={getCurrentNews().image}
                alt={getCurrentNews().title}
                onError={(e) => {
                  e.target.src = `https://picsum.photos/seed/chess-news-${getCurrentNews().id}/600/400`;
                }}
              />
        
              <div className="carousel-content">
                <h2>{getCurrentNews().title}</h2>
                <p>{getCurrentNews().description}</p>
                         
              </div>
            </>
          ) : (
            <div className="carousel-content">
              <h2>Loading...</h2>
              <p>Loading recent news...</p>
            </div>
          )}
        </div>

        <button className="nav-btn left" onClick={prev}>‹</button>
        <button className="nav-btn right" onClick={next}>›</button>
      </div>
    </section>
  );
}